export const getProviderAndOperatoryStatus = (providerName?: string, operatoryName?: string) => {
  if (providerName && operatoryName)
    return `${providerName} in ${operatoryName}`;

  if (providerName) return providerName;

  if (operatoryName) return operatoryName;

  return null;
}